import React from "react";

export default class ExamPerformancePercentageChartComponent extends React.PureComponent<{ totalQuestion: number, chartData?: { title: string, value: number, color: string }[] }, {}> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.setData();
    }

    setData() {
        let Highcharts = require('highcharts');

        let plotOptions = {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',

                dataLabels: {
                    enabled: false
                },

                showInLegend: true
            }
        };
        let series = [{
            minPointSize: 10,
            innerSize: '40%',
            zMin: 0,
            showInLegend: true,
            type: 'pie',
            data: this.props.chartData?.map(item => {
                return {
                    name: item.title,
                    y: (item.value / this.props.totalQuestion) * 100,
                    z: 92.9,
                    color: item.color
                }
            })
        }]
        let json = {
            chart: {
                spacingLeft: 10,
                spacingRight: 10,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
            },
            title: {
                text: ''
            },
            legend: {
                layout: 'vertical',
            },
            tooltip: {
                pointFormat: '<br/>%{point.percentage:.1f}'
            },
            plotOptions,
            series
        };


        Highcharts.chart('performance-percentage-container', json);
    }

    render(): React.ReactNode {
        return (<>
            <div id="performance-percentage-container"></div>
        </>);
    }
}